var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson")

function CheckStationWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.browserGUID = ko.observable(null);
  self.delegate = null;
  self.ticketClassifierId = ko.observable(null);
  self.name = 'CheckStationWS';			// Convenience name for debugging


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/station';
  });


	/**
	 * DESCRIPTION
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {CheckStationWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);
    if (json) {

      var guid = json.stationMetadata.browserGUID || null;
      var classifier = json.stationMetadata.ticketClassifierId || null;

      self.browserGUID(guid);
      self.ticketClassifierId(classifier);

      if (self.delegate) {
        var del = self.delegate;
        del.call(null);
        self.delegate = null;
      }
    }

    // Return self (CheckStationWS) to be chainable, for best practice
    return self;
  };


	/**
	 * Resets the component to it's default state
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function () {
    self.browserGUID(null);
    self.delegate = null;
    self.ticketClassifierId(null);
  };

  /**
   * Indicates whether an Employee has updated their Station Metadata
   * This method should probably have a better name.
   */
  self.hasBrowserGUID = function () {
    return self.browserGUID() !== null;
  };

  // Return self as API
  return self;
};

CheckStationWS.prototype = AbstractWS.prototype;
CheckStationWS.prototype.constructor = CheckStationWS;

module.exports = CheckStationWS
